<template>

    <Dialog :dialog="dlg">
        <template v-slot:title>{{dlg.currentFile?.fileTitle}}</template>
        <div v-if="dlg.currentFile?.isImage" class="image-viewer position-relative">
            <img
                :src="dlg.currentFile.url"
                class="image-viewer-image"
                style="width:100%"
                contain
            />
        </div> 
        <div v-else class="image-viewer">
            <v-row class="text-center">
                <v-col>
                    <Icon type="example" size="xl" />
                    <div class="caption pa-4">
                        <a :href="dlg.currentFile?.url" target="_blank">
                            Open {{dlg.currentFile?.type}} bestand 

                        </a>
                    </div>
                </v-col>
            </v-row>
        </div>
        <template v-slot:footer-left>
            <v-row>
                <v-col sm="auto">
                    <v-btn icon @click="dlg.prev()">
                        <Icon type='chevronleft' ></Icon>
                    </v-btn>
                    {{ dlg.index+ 1 }} / {{ dlg.files.length }}
                    <v-btn icon @click="dlg.next()">
                        <Icon type='chevronright'></Icon>
                    </v-btn>    
                </v-col>
                <v-col v-if="dlg.currentFile?.note" class="text-center caption pr-4">
                    
                    {{ dlg.currentFile.note }}
                </v-col>
            </v-row>
        </template>

    </Dialog>

</template>

<script setup>

    import Dialog from '@shared/ui/dialogs/ActionDialog'
    import clsDialog from '@cls/clsDialog'
    import eventbus from '@app/eventbus'
    import string from '@lib/string'
    import { ref, computed } from 'vue'
    import Icon from '@controls/icons/Icon'

    /**
     * Start an image viewer for one or more images.
     * 
     *  params = { [ files ] }
     *  params = {
     *      files: [
     *               { 
     *                  name: 'filename.jpg', 
     *                  url: 'https://example.com/image.jpg' 
     *               },
     *               { 
     *                  name: 'filename2.jpg', 
     *                  url: 'https://example.com/image2.jpg' 
     *               },
     *             ]
     *  }
     * 
     * dlg.imageViewer(params);
     * 
     */

     class clsPreviewFile {

        filename = "";
        url = "";
        title = "";
        note = "";

        constructor({filename, url, title, note}) {
            this.filename = filename || "";
            this.url = url || "";
            this.title = title || "";
            this.note = note || "";            
        }

        get fileTitle () {
            if (this.title) {
                return this.title;
            }
            return this.filename || "";
        }

        // var files = clsPreviewFile.map(this.attachments, (att)=> {filename: att.filename, url: att.url, title: att.title || ""});
        static map(data, fn) {
            if (!fn || !data || !data.length) {
                return [];
            }
            if (!Array.isArray(data)) {
                throw new Error("clsPreviewFile.map: data must be an array");
            }
            return data.map(function(item) {
                var mapped = fn(item); 
                if (!mapped || !mapped.url) {
                    console.warn("clsPreviewFile.map: url not found for item", item);
                    return null;
                }
                return new clsPreviewFile({url: mapped.url, filename: mapped.filename, title: mapped.title || "", note: mapped.note})
            }).filter(item => item !== null);            
        }

        get isImage() {
            return this.url && (
                string.endsWith(this.url, '.jpg') 
                || string.endsWith(this.url, '.webp') 
                || string.endsWith(this.url, '.jpeg') 
                || string.endsWith(this.url, '.png') 
                || string.endsWith(this.url, '.gif')
            );
        }
        get type() {
            if (!string.contains(this.url, '.')) {
                return null;
            }
            return this.url.split('.').pop().toLowerCase();
        }
     }
    window. clsPreviewFile = clsPreviewFile;
    class clsDialogImageViewer extends clsDialog {
        body = "";
        files=[];
        index = 0; 

        get currentFile() {
            if (this.files && this.files.length > 0) {
                return this.files[this.index];
            }
            return null;
        }
        next() {
            if (!this.files || !this.files.length) {
                this.index = 0;
            } else if (this.index >= this.files.length -1) {
                this.index = 0; 
            } else {
                this.index++;
            }
        }
        prev() {
            if (!this.files || !this.files.length) {
                this.index = 0;
            } else if (this.index == 0) {
                this.index = this.files.length -1; 
            } else {
                this.index--;
            }
        }    

        onOpen(params) {
            this.onCreate(params);
        }
        onCreate(params) {
            console.log("clsDialogImageViewer.onCreate", params);
            params = params || {};
            this.index = 0; 

            this.files = clsPreviewFile.map(params.files || [], (item) => item);
            if (params.selectedUrl) {
                for (var n = 0; n < this.files.length; n++) {
                    if (this.files[n].url === params.selectedUrl) {
                        this.index = n;
                        break;
                    }
                }
            }
            if (!this.files || this.files.length === 0) {
                console.warn("clsDialogImageViewer.onCreate: no files provided");
                return;
            }            
            this.open = true;
        }
        /**
         * Instead of open on the eventbus.dialog.open event, use the dialog event. It is for backward compatibillity.
         */
        registerEvents() {
            var self = this;
            this.evtRegistrations.push(
                eventbus.dialog.imageviewer.on((params) => {
                    self.onOpen(params);
                })
            )
        }
    }

    let dlg = ref (new clsDialogImageViewer("imageViewer", "ImageViewer", {}, [], {
        icon: 'example', save: null, cancel: 'Sluit', noSubTitle: true, maxWidth:800,
    }));

    // var files = [ { url: "https://cdn.test.optimit.nl/c/5/2025/06/werkbon/10/2218179xiu4CmvHCBwr3xBizX6.jpg" }, { url: "https://cdn.test.optimit.nl/c/5/2025/06/werkbon/10/2218182xO9HPwErkXp5idPduKp.jpg" },]
    // _m.eventbus.eventbus.dialog.imageviewer({files: files})
    // dlg.imageviewer({files: files});
    window.div = dlg;
</script>